import Topo from "Components/Topo";
import jsonData from '../../json/cadastro.json';
import { useEffect, useState, React, useRef, useCallback  } from "react";
import Webcam from "react-webcam";
import Helper from "Helper";
import Campos from "Components/Campos";
import Camera from "Components/Camera";
import swal from "sweetalert";
import { API_BASE } from "API";

function AbreCamera(){
  const wrapper = document.createElement('div');
  wrapper.innerHTML = <Camera />;
  swal({
    title: "Faça a captura da foto",
    content: wrapper,
    className: "alert_title", 
    icon: "error"
  });
}

function createMarkup(conteudo) {
  return {__html: conteudo};
}

function setInjetaHtml(id,conteudo){
  return <div dangerouslySetInnerHTML={createMarkup(conteudo)} />;
}

function Cadastro(){
  let duas_colunas=true;//Aqui controla se tem uma ou duas colunas
  const url = API_BASE+"getCadastro.php?access_token="+sessionStorage.getItem("token")+"&form="+sessionStorage.getItem("form")+"&ref="+sessionStorage.getItem("referencia");
  const [data, setData] = useState(null);
  
  useEffect(() => {
    // Função para buscar os dados do JSON
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const jsonData = await response.json();
        if ("dev" === sessionStorage.getItem('md') || "DEV" === sessionStorage.getItem('md')) {
           console.log('jsonData:', jsonData);
        }
        setData(jsonData);
      } catch (error) {
        if(sessionStorage.getItem('md') == 'dev'){
             console.error('Erro ao buscar dados:', error);
            console.log(jsonData);
        }
      }
    };

    fetchData();
  }, []);

  if ("dev" === sessionStorage.getItem('md') || "DEV" === sessionStorage.getItem('md')) {
    console.log('data:', data);
  }
  if( data && data.form && data.campos ){
        sessionStorage.setItem("tipo",data.form[0].tipo);
        sessionStorage.setItem("categoria",data.form[0].categoria);
  }
  // <Topo texto="REVIEW" cor_fundo="fundoCadastro" cor_texto="text-white"><Topo />-->
  return (
    data && data.form && data.campos ? (
      <>
      {undefined != data.form[0].logo && null != data.form[0].logo && data.form[0].logo !="" ?
         <div className="logo">
            <img src={data.form[0].logo} className="w-full h-full object-contain"/>
         </div>
      :''}
        <div className="flex">
          <form className="max-w-4xl mx-auto p-4">
                <input type="hidden" name="cod_empresa" id="cod_empresa" autoComplete="off" value={(data.cadastro[0].cod_empresa > 0 ? data.cadastro[0].cod_empresa:'')} />
                <input type="hidden" name="cod_inscricao" id="cod_inscricao" autoComplete="off" value={(data.cadastro[0].cod_palestrante > 0 ? data.cadastro[0].cod_inscricao:'')} />
                <input type="hidden" name="cod_palestrante" id="cod_palestrante" autoComplete="off" value={(data.cadastro[0].cod_palestrante > 0 ? data.cadastro[0].cod_palestrante : '')} />
                      
            {data.form.map((f, index) => (
              <div key={index}>
                <div className="titulo">{f.titulo}</div>
                <br />
                <div className="descricao" id="conteudo">{setInjetaHtml('conteudo', f.descricao)}</div>
                <br />
                <div className={`grid grid-cols-1 gap-4 `+(duas_colunas ?'md:grid-cols-2':'')}> 
                  {data.campos.map((item) => (
                    <div
                      key={item.cod_campo}
                      data-c={item.cod_campo}
                      className={`flex flex-col divs`}
                    >
                      <Campos item={item} />
                    </div>
                  ))}
                </div>
                <br />
              </div>
            ))}
          </form>
        </div>
        <br />
        <div id="loading" className="fixed inset-0 flex justify-center items-center bg-white esconde_primeiro"></div>
        <div className="flex justify-center">
          <p>Após preencher e verificar os dados clique em Confirmar</p>
        </div>
        <br />
        <div className="flex justify-center space-x-8">
          <div key='1000000' className='flex flex-col divs'>
            <button
              className="w-[15vw] bg-green-500 hover:bg-green-700 text-white font-bold px-4 py-2 rounded mb-3 btn-celular"
              onClick={() => { Helper.validaInscricao(1) }}
              id="btn_confirma"
            >
              Confirmar
            </button>
          </div>
          
        </div>
      </>
    ) : (
      <p>Carregando...</p>
    )
  );
}

export default Cadastro;